export default "__VITE_ASSET__DJQ1K1ig__"